export default __webpack_public_path__ + "static/screenshot-5-180d78006bcb87a8438d745a69e931db.png";